export default __webpack_public_path__ + "static/media/sentmessage.39de0812.mp3";